import { useEffect, useState, useMemo } from "react";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Container, ListItemIcon, Button, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import { getData } from "../../../../../services/library";
import Alert from "@mui/material/Alert";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import DetalleDireccion from "./DetalleDireccion";
import AltaDireccionEnv from "./AltaDireccionEnv";
import EdicionDireccionEnv from "./EdicionDireccionEnv";
import BajaDireccionEnv from "./BajaDireccionEnv";
import PeopleIcon from "@mui/icons-material/People";
import { LockOutlined } from "@mui/icons-material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function DireccionesEntregaEnv(props) {
  const [dataCliente, setDataCliente] = useState(props.cliente);
  const [tabladir, setTabladir] = useState(true); //Estado para mostrar o no la tabla de direcciones de entrega
  const [direcciones, setDirecciones] = useState([{}]); //Estado para guardar las direcciones de entrega
  const [alta, setAlta] = useState(false);
  const [editar, setEditar] = useState(false);
  const [baja, setBaja] = useState(false);
  const [direccion, setDireccion] = useState({});
// Obtener sucursales autorizadas del localStorage
const sucursalesAutorizadas = useMemo(() => {
  const sucAuthStr = localStorage.getItem("suc_auth");
  if (!sucAuthStr) return [];
  
  try {
    const parsed = JSON.parse(sucAuthStr);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return sucAuthStr.split(',').map(item => item.trim()).filter(Boolean);
  }
}, []);

// Verificar si una dirección específica es editable
const esDireccionEditable = (direccion) => {
  if (!sucursalesAutorizadas.length || !direccion.id_sucursal) return false;
  return sucursalesAutorizadas.includes(String(direccion.id_sucursal));
};

  const obtenerDirecciones = () => {
    getData(
      "/envasado_direcciones_entrega/cli/" + dataCliente.id,
      setDirecciones
    );
  };

  useEffect(() => {
    obtenerDirecciones();
  }, [tabladir, alta]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "nombre_direccion", //access nested data with dot notation
        header: "Lugar De Entrega",
        size: 150,
      },
      {
        accessorKey: "direccion_entrega", //access nested data with dot notation
        header: "Dirección",
        size: 150,
      },
      {
        accessorKey: "sucursal", //access nested data with dot notation
        header: "Sucursal",
        size: 20,
      },
      {
        accessorKey: "localidad", //access nested data with dot notation
        header: "Localidad",
        size: 20,
      },
      {
        accessorKey: "nombre_zona", //access nested data with dot notation
        header: "Zona",
        size: 20,
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageSize: direcciones && direcciones.length > 5 ? 10 : 5,
      pageIndex: 0,
    },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };
  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  return (
    <div>
      {tabladir && (
        <MaterialReactTable
          columns={columns}
          enableTopToolbar={true}
          data={direcciones ?? [{ direccion_entrega: "Example" }]}
          enableColumnFilterModes={false}
          enableColumnOrdering={false}
          enableGrouping={false}
          localization={customLocalization}
          enablePinning={true}
          enableRowActions={true}
          initialState={initialState}
          enableRowSelection={false}
          positionActionsColumn={"last"}
          enableHiding={false}
          muiTableHeadCellProps={tableHeadCellProps}
          positionExpandColumn={"first"}
          renderDetailPanel={({ row }) => (
            <DetalleDireccion
              direccion={row.original}
              actulizar={obtenerDirecciones}
              cliente={dataCliente}
            />
          )}
          enableExpandAll={false}
          muiTableBodyCellProps={({ row }) => ({
            align: "center",
            sx: {
              backgroundColor: "#ffffff",
              color: "black",
              borderColor: "#FDFEFE",
            },
          })}
          renderTopToolbarCustomActions={(row, table) => (
            <>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddLocationAltIcon />}
                onClick={() => {
                  setAlta(true);
                }}
              >
                Nueva Dirección
              </Button>
              <Typography variant="poster" fontSize={26}>
                <PeopleIcon sx={{ fontSize: 20 }} />
                Direcciones de Entrega de {props.cliente.razon_social}
              </Typography>
            </>
          )}
          enableColumnActions={false}
          enableColumnFilters={false} //Quita filtros por columna
          displayColumnDefOptions={displayColumnDefOptions}
          enableDensityToggle={false}
          // renderRowActionMenuItems={({ closeMenu, row, index }) => [
          //   <MenuItem
          //     key={index}
          //     onClick={() => {
          //       setDireccion(row.original);
          //       setEditar(true);
          //       closeMenu();
          //     }}
          //     sx={{ m: 0 }}
          //   >
          //     <ListItemIcon>
          //       <BorderColorIcon color="primary" />
          //     </ListItemIcon>
          //     Editar
          //   </MenuItem>,
          //   <MenuItem
          //     key={index}
          //     onClick={() => {
          //       closeMenu();
          //       setDireccion(row.original);
          //       setBaja(true);
          //     }}
          //     sx={{ m: 0 }}
          //   >
          //     <ListItemIcon>
          //       <Delete color="error" />
          //     </ListItemIcon>
          //     Eliminar
          //   </MenuItem>,
          // ]}
          renderRowActionMenuItems={({ closeMenu, row, index }) => {
  const direccionActual = row.original;
  const puedeEditar = esDireccionEditable(direccionActual); 
  
  // Si no tiene permisos para esta dirección, no mostrar opciones
  if (!puedeEditar) return [
  <MenuItem
      key={index}
      onClick={() => {
        closeMenu();
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <InfoOutlinedIcon color="warning" />
      </ListItemIcon>
      No se puede editar la dirección, 
      no pertenece a tu sucursal
    </MenuItem>,

  ];
  
  return [
    <MenuItem
      key={index}
      onClick={() => {
        setDireccion(direccionActual);
        setEditar(true);
        closeMenu();
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <BorderColorIcon color="primary" />
      </ListItemIcon>
      Editar
    </MenuItem>,
    <MenuItem
      key={index}
      onClick={() => {
        closeMenu();
        setDireccion(direccionActual);
        setBaja(true);
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <Delete color="error" />
      </ListItemIcon>
      Eliminar
    </MenuItem>,
  ];
}}
        />
      )}
      {editar ? (
        <EdicionDireccionEnv
          tipoCliente={dataCliente.id_tipocliente}
          direccion={direccion}
          open={editar}
          setOpen={setEditar}
          actualizar={obtenerDirecciones}
        />
      ) : null}
      {baja ? (
        <BajaDireccionEnv
          direccion={direccion}
          open={baja}
          setOpen={setBaja}
          actualizar={obtenerDirecciones}
        />
      ) : null}
      {alta ? (
        <AltaDireccionEnv
          open={alta}
          setOpen={setAlta}
          cliente={dataCliente}
          actualizar={obtenerDirecciones}
        />
      ) : null}
    </div>
  );
}

export default DireccionesEntregaEnv;
